module.exports = __webpack_public_path__ + "img/ts.0164f463.png";